import { render } from "./ArchivedStoreBanner.vue?vue&type=template&id=22937590&scoped=true"
import script from "./ArchivedStoreBanner.vue?vue&type=script&lang=js"
export * from "./ArchivedStoreBanner.vue?vue&type=script&lang=js"

import "./ArchivedStoreBanner.vue?vue&type=style&index=0&id=22937590&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22937590"]])

export default __exports__